export default __webpack_public_path__ + "static/principle-sentient-light-75837c9bb22b3b49111bf248a9f424c2.png";